import React, { memo, useRef, useCallback } from 'react';
import './ImmoAssistantButton.css';

export interface ChatButtonProps {
  onClick?: () => void;
}

const ChatButton: React.FC<ChatButtonProps> = ({ onClick = () => {} }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      // Prevent any default browser behavior
      e.preventDefault();

      // Immediately blur the button to prevent focus states from sticking
      e.currentTarget.blur();

      // Call the onClick handler
      onClick();
    },
    [onClick],
  );

  return (
    <button
      ref={buttonRef}
      className='immo-assistant-button'
      type='button'
      onClick={handleClick}
      aria-label='Open chat assistant'
      data-testid='chat-button'
    >
      <span className='immo-assistant-button-icon'>
        <svg width='36' height='36' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fill='currentColor'
            d='M36 16.011H25V13.91a5.01 5.01 0 0 0 2.353-8.617 4.997 4.997 0 0 0-8.328 3.21A5.01 5.01 0 0 0 23 13.91v2.102H12l-5 10.01v2.003a6.01 6.01 0 0 0 1.757 4.247 5.997 5.997 0 0 0 8.486 0A6.009 6.009 0 0 0 19 28.024v-2.002l-4-8.009h18l-4 8.009v2.002c0 1.593.632 3.12 1.757 4.247a5.997 5.997 0 0 0 8.486 0A6.009 6.009 0 0 0 41 28.024v-2.002l-5-10.01ZM21 9.004a3.005 3.005 0 0 1 1.852-2.774 2.997 2.997 0 0 1 4.09 2.188 3.006 3.006 0 0 1-1.275 3.083A2.998 2.998 0 0 1 21 9.004Zm-8 23.024a4.006 4.006 0 0 1-4-4.004h8a4.006 4.006 0 0 1-4 4.004Zm3.76-6.006H9.24L13 18.444l3.76 7.578ZM35 18.444l3.76 7.578h-7.52L35 18.444Zm0 13.584a4.006 4.006 0 0 1-4-4.004h8a4.006 4.006 0 0 1-4 4.004Z'
          />
          <path fill='currentColor' d='m25 19.975-2 1.001v21.022h-8V44h18v-2.002h-8V19.975Z' />
        </svg>
      </span>
    </button>
  );
};

export default memo(ChatButton);
